<script>
  export let conversation = null;
  export let isGroup = false;
  export let isDirect = false;
  export let memberCount = 0;
</script>

<div class="space-y-2 px-4 pb-4 text-[12px] text-slate-600">
  <div class="info-row">
    <span>Tên</span>
    <strong>{conversation?.title || 'Hội thoại'}</strong>
  </div>
  <div class="info-row">
    <span>Loại</span>
    <strong>{isGroup ? 'Nhóm' : isDirect ? 'Trò chuyện riêng' : 'My Cloud'}</strong>
  </div>
  {#if isGroup || isDirect}
    <div class="info-row">
      <span>Thành viên</span>
      <strong>{memberCount}</strong>
    </div>
  {/if}
  {#if isDirect}
    <div class="info-row">
      <span>Trạng thái</span>
      <strong>{conversation?.online ? 'Đang online' : 'Offline'}</strong>
    </div>
  {/if}
</div>

<style>
  .info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
  }

  .info-row span {
    color: #64748b;
  }

  .info-row strong {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #0f172a;
    font-weight: 600;
  }
</style>
